/* terminal/actions */
import { action } from "typesafe-actions";
import { CloseLoop, CloseLoopActionTypes } from "./types";

export const fetchRequest = (
  id?: string | null,
  params?: {},
  callback?: () => unknown | null
) => action(CloseLoopActionTypes.FETCH, { id, params, callback });

export const fetchSuccess = (closeloop: CloseLoop) =>
  action(CloseLoopActionTypes.FETCH_SUCCESS, closeloop);

export const fetchError = (error: string) =>
  action(CloseLoopActionTypes.FETCH_ERROR, error);
